import { PLANS } from 'zync-common/zyncCustomerPlans';

export const isSoloPlan = (workspacePlan) => {
  return (
    workspacePlan === PLANS.solo.id ||
    workspacePlan === PLANS.solo_starter_monthly.id
  );
};
